/** Share a world's link (the system share sheet, where there is one) or copy it. */
import { useState, type JSX } from 'react';

import { inviteTo } from '@game/session/invite';
import type { WorldInfo } from '@game/types';
import { t } from '@i18n/index';

export function ShareButtons({ world }: { world: WorldInfo }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const { link } = inviteTo(world.id);
  const canShare = typeof navigator.share === 'function';
  const copy = (): void => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => undefined);
  };
  const share = (): void => {
    navigator
      .share({ title: world.name, text: t('world.share-text', { world: world.name }), url: link })
      .catch(() => undefined);
  };
  return (
    <div className="row-btns">
      {canShare && (
        <button type="button" className="btn small primary" onClick={share}>
          {t('world.share')}
        </button>
      )}
      <button type="button" className="btn small" onClick={copy}>
        {copied ? t('world.copied') : t('world.copy-link')}
      </button>
    </div>
  );
}
